import { useCallback, useMemo, useState } from "react";

/**
 * Hidden-column set for a DataTable, remembered per table in localStorage
 * (best-effort — private mode throws). Pass the result straight in:
 *   const cols = useColumnVisibility("users.table");
 *   <DataTable columnVisibility={cols} … />
 */
export function useColumnVisibility(storageKey: string, initialHidden: Iterable<string> = []) {
	const key = `gms.columns.${storageKey}`;
	const [hidden, setHidden] = useState<Set<string>>(() => {
		try {
			const raw = localStorage.getItem(key);
			if (raw) return new Set(JSON.parse(raw) as string[]);
		} catch {
			/* fall through */
		}
		return new Set(initialHidden);
	});
	const onChange = useCallback(
		(next: Set<string>) => {
			setHidden(next);
			try {
				localStorage.setItem(key, JSON.stringify([...next]));
			} catch {
				/* best-effort */
			}
		},
		[key],
	);
	return useMemo(() => ({ hidden, onChange }), [hidden, onChange]);
}
